/** Sex codes stored in staff profiles */
export const SEX = {
	male: 'male',
	female: 'female',
} as const

export type SexCode = (typeof SEX)[keyof typeof SEX]

export const SEX_OPTIONS: { value: SexCode; label: string }[] = [
	{ value: SEX.male, label: 'Male' },
	{ value: SEX.female, label: 'Female' },
]

export const toGenderLabel = (g: string) => {
	switch (g) {
		case SEX.male:
			return 'Male'
		case SEX.female:
			return 'Female'
		default:
			return 'Other'
	}
}
